module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/img (9).e961977b.jpg";